<!--imageSource is the name of the image located in src/assets/images/insight_thumbnails/
    WITHOUT .png extension - Only the filename.
    All insight thumbnails should be located at the above filepath
    Filename specified in insights page .html file-->

<mat-card class="insight-mat-card">
    <div
        class="dashboard-module-card {{ module + '-insight-card' }} alternative-card"
        routerLink="/{{ insightLink }}"
    >
        <span id="title">{{ insightTitle }}</span>
        <span class="image">
            <img
                class="insight-image"
                src="src/assets/images/insight_thumbnails/{{ imageSource }}.png"
                alt="Thumbnail"
            />
        </span>
        <span class="description">
            {{ insightDescription }}
        </span>
        <span *ngIf="isLocked">
            <br />
            <mat-icon fontSet="fas" fontIcon="fa-lock"></mat-icon>
        </span>
    </div>
</mat-card>
